import { createAction } from 'redux-actions';

import types from './types';

const chooseProductWrap = createAction(types.CHOOSE_PRODUCT_WRAP);
const selectProductWrap = createAction(types.SELECT_PRODUCT_WRAP);
const setProductWrapMetadata = createAction(types.SET_PRODUCT_WRAP_METADATA);
const setSelectedProductWrap = createAction(types.SET_SELECTED_PRODUCT_WRAP);
const updateWrapMessage = createAction(types.UPDATE_WRAP_MESSAGE);
const updateAppliedOptionMessage = createAction(types.UPDATE_APPLIED_OPTION_MESSAGE);
const setGiftOptionData = createAction(types.SET_GIFT_OPTION_DATA);
const setAppliedGiftOption = createAction(types.SET_APPLIED_GIFT_OPTION);
const setGiftData = createAction(types.SET_GIFT_DATA);
const saveGiftData = createAction(types.SAVE_GIFTOPTIONS);
const removeGiftData = createAction(types.REMOVE_GIFTOPTION);
const showEmptyMsgError = createAction(types.SHOW_EMPTY_MSG_ERROR);
const cleanSelectedWrapEntries = createAction(types.CLEAN_SELECTED_WRAP_ENTRIES);
const updateEmptyMsgFeatureFlag = createAction(types.UPDATE_EMPTY_MSG_FEATURE_FLAG);

export default {
    chooseProductWrap,
    selectProductWrap,
    setProductWrapMetadata,
    setSelectedProductWrap,
    updateWrapMessage,
    updateAppliedOptionMessage,
    cleanSelectedWrapEntries,
    setGiftOptionData,
    setGiftData,
    setAppliedGiftOption,
    saveGiftData,
    removeGiftData,
    showEmptyMsgError,
    updateEmptyMsgFeatureFlag,
};
